import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import { BTN_BURGER_TITLE } from './constants'

import * as s from './BtnAnimatedBurger.module.scss'

const BtnAnimatedBurger = (props) => {
  const { className, isModalOpen, onClick, ...rest } = props

  return (
    <button
      {...rest}
      type="button"
      className={cn(s.hamb, className)}
      onClick={onClick}
      aria-expanded={isModalOpen}
      {...(isModalOpen
        ? {
            'aria-label': BTN_BURGER_TITLE.open,
            title: BTN_BURGER_TITLE.open,
          }
        : {
            'aria-label': BTN_BURGER_TITLE.closed,
            title: BTN_BURGER_TITLE.closed,
          })}
    >
      <svg fill="none" viewBox="0 0 24 24" className={s.hamb_icon}>
        <path
          className={cn(s.hamb_line, s.hamb_line_top)}
          d="M4 8h16 c1 0 3 .4 3 2s-2 2-3 2 h-8"
        />
        <path className={cn(s.hamb_line, s.hamb_line_middle)} d="M4 12 h16" />
        <path
          className={cn(s.hamb_line, s.hamb_line_bottom)}
          d="M20 16 h-16 c-1 0-3 -.4-3 -2s2 -2 3 -2h8"
        />
      </svg>
    </button>
  )
}

BtnAnimatedBurger.defaultProps = {
  className: undefined,
  isModalOpen: false,
  onClick: undefined,
}

BtnAnimatedBurger.propTypes = {
  className: PropTypes.string,
  isModalOpen: PropTypes.bool,
  onClick: PropTypes.func,
}

export default BtnAnimatedBurger
